<template>
  <q-page>
    <div v-if="eventsStore.item !== null" class="be-main-lr q-mt-lg q-pb-lg q-mb-lg">
      <div class="row q-col-gutter-md">
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="be-page-title q-mt-md q-mb-md mobile-only" v-html="eventsStore.item.name"></div>
          <picture v-if="eventsStore.item.background !== null">
            <source :srcset="$assetsUrl() + eventsStore.item.background.split('.')[0] + '.webp'" type="image/webp" />
            <img
              :src="$assetsUrl() + eventsStore.item.background"
              :alt="eventsStore.item.name"
              class="event-view-background"
            />
          </picture>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6">
          <div class="be-page-title q-mb-md desktop-only" v-html="eventsStore.item.name"></div>
          <q-card flat class="be-card" style="margin-bottom: 26px">
            <q-card-section style="padding-top: 0">
              <div class="row">
                <div class="col">
                  <div class="be-text-16" style="padding: 8px 8px 0 8px">
                    <div class="row q-col-gutter-sm q-mt-sm">
                      <div class="col-auto">
                        <q-icon name="app:location" class="be-icon-16" />
                      </div>
                      <div class="col">{{ eventsStore.item.store_name }}</div>
                    </div>
                    <div class="row q-col-gutter-sm q-mt-sm">
                      <div class="col-auto">
                        <q-icon name="app:events" class="be-icon-16" />
                      </div>
                      <div class="col">
                        {{ printEventDate(eventsStore.item.date_start_at, eventsStore.item.date_end_at) }}
                      </div>
                    </div>
                    <div class="row q-col-gutter-sm q-mt-sm q-mb-md">
                      <div class="col-auto">
                        <q-icon name="app:ticket" class="be-icon-20" style="vertical-align: text-bottom" />
                      </div>
                      <div v-if="eventsStore.item.price !== null" class="col">
                        {{ $formatCurrency(eventsStore.item.price, currency) }}
                      </div>
                      <div v-else class="col">{{ $t('events.free-entrance') }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-auto q-pt-md">
                  <router-link :to="`/contact/${eventsStore.item.store_url}`" class="text-green">{{
                    $t('events.see-location')
                  }}</router-link>
                </div>
              </div>
            </q-card-section>
          </q-card>
          <div v-html="eventsStore.item.info"></div>
          <div class="q-ma-lg text-center">
            <q-btn
              v-if="eventsStore.isCurrentEvent"
              style="max-width: 80%"
              class="be-btn-l bg-black text-white full-width"
              :label="$t('events.send-reservation')"
              :to="`/reservations?event_id=${eventsStore.item.id}`"
            />
          </div>
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { date, createMetaMixin } from 'quasar'

import { mapState, mapStores } from 'pinia'
import { useEventsStore } from 'stores/events'
import { useSettingsStore } from 'stores/settings'

export default {
  name: 'EventPage',
  mixins: [
    createMetaMixin(function mymeta() {
      return {
        title: `${this.$t('events.title')} - ${this.websiteName}`,
        meta: {
          description: {
            name: 'description',
            content: `${this.$t('events.title')} - ${this.websiteName}`
          }
        }
      }
    })
  ],
  computed: {
    ...mapStores(useEventsStore),
    ...mapState(useSettingsStore, {
      currency: store => store.localization.currency,
      timezone: store => store.localization.time_zone,
      websiteName: store => store.website.name
    })
  },
  preFetch({ store, currentRoute }) {
    const eventsStore = useEventsStore(store)
    return new Promise(resolve => {
      eventsStore.fetchByUrl(currentRoute.params.url).then(() => {
        resolve()
      })
    })
  },
  methods: {
    printEventDate(startDate, endDate) {
      if (startDate.substr(0, 10) === endDate.substr(0, 10)) {
        return `${this.convertDate(startDate, 'DD.MM.YYYY, HH:mm')} - ${this.convertDate(endDate, 'HH:mm')}`
      }
      return `${this.convertDate(startDate)} - ${this.convertDate(endDate)}`
    },
    convertDate(mysqlTimestamp, newFormat = 'HH:mm DD.MM.YYYY') {
      const t = mysqlTimestamp.split(/[- :]/)
      let d = new Date(Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]))
      d = d.toLocaleString('en-US', { timeZone: this.timezone })
      return date.formatDate(d, newFormat)
    }
  }
}
</script>
